// extracted by mini-css-extract-plugin
export default {"section":"Section_section__0XkUm","header":"Section_header__9ou4r","circle":"Section_circle__ANBC4","circleContent":"Section_circleContent__sGrb5","title":"Section_title__ucHMb"};